<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare :content='content' :padding='false'></SmallSquare>
      <div class="m-b-20 m-t-20 s_flex_bian_c">
        <div>
          <span class='mr15'>
            <a-button type="primary" v-has:dealerCreate="()=> {$router.push('/customer/dealer/dealer_add?type=add')}">
              <PlusOutlined />
              添加经销商
            </a-button>
          </span>
          <span class='mr15'>
            <a-button type="primary" v-has:dealerExport="exportTable">
              导出经销商
            </a-button>
          </span>
          <!-- <span class='mr15'>
            <a-button type="primary" v-has:agentAdd="()=> agentAdd('add')">
              <PlusOutlined />
              批量导入经销商
            </a-button>
          </span> -->
       <span class='mr15'>
            <a-button type="primary" v-has:batchEditSubBrand="()=> batchEditSubB()">
              <EditOutlined />
              批量修改经销商品牌
            </a-button>   
          </span>
        </div>
        <div>
          <span class='mr15'>
            <a-button type="primary" ghost v-has:dealerInvitation="()=>{visibleInvite = !visibleInvite}">
              邀请注册经销商
            </a-button>
          </span>
          <span>
            <a-button type="primary" ghost v-has:dealerLoginUrl="()=>getLink(1)">
              经销商登录地址
            </a-button>
          </span>
        </div>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search"
        :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="" name='keywords'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.type" style="width: 40%" @change="inputSelect">
              <a-select-option value="dealer_name">经销商名称</a-select-option>
              <a-select-option value="dealer_sn">经销商编号</a-select-option>
              <a-select-option value="leader_name">负责人</a-select-option>
              <a-select-option value="leader_phone">手机号</a-select-option>
              <!-- <a-select-option value="leader_wx">微信号</a-select-option> -->
            </a-select>
            <a-input style="width: 60%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="经销商级别" name='level_id'>
          <a-select v-model:value="search.level_id" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='item in levelList' :key='item.level_id' :value="item.level_id">{{item.level_name}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态" name='level_id'>
          <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="所属上级">
          <a-input v-model:value="search.name" readonly placeholder='请选择上级经销商' style="width:60%" />
          <a-button type="primary" @click='showDealer = true;dealer_type=1'>
            选择
          </a-button>
        </a-form-item>
        <a-form-item label="销售大区" name='level_id' >
          <a-input v-model:value="search.areaText" placeholder="销售大区" readonly />
        </a-form-item>
        <a-form-item label="" name='level_id' >
          <a-button type="" @click="search.areaText='';search.sale_cat_id=[]" class="m-r-10">
            清除
          </a-button>
          <a-button type="primary" @click="showDealerArea=true">
            选择
          </a-button>
        </a-form-item>
        <a-form-item label="创建日期" name='time' >
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item label="绑定微信账号" name='is_bind_wechat' >
          <a-select v-model:value="search.is_bind_wechat" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">绑定微信</a-select-option>
            <a-select-option :value="2">未绑定微信</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button type="primary" ghost>导出</a-button>
        </a-form-item> -->
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='dealer_id' :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns='columns' :data-source='data' class="tableFixBox" :scroll="{ x: 'max-content'}">
        <template v-slot:dealer_name="{ record }">
          <p>{{record.dealer_name}}</p>
          ({{record.level_name}})
        </template>
        <template v-slot:account="{ record }">
          <a-popover placement="right" v-if='record.wechat'>
            <template #content>
              <div class="s_flex_ali">
                <img class="width-100 height-100 m-r-15" :src="record.wechat ? record.wechat.headimgurl :''" alt="">
                <div>
                  <p class="s_c333 s_lin_h28">微信昵称：{{record.wechat ? record.wechat.nick_name :'-'}}</p>
                  <p class="s_c333 s_lin_h28">客户ID：{{record.wechat ? record.wechat.id :'-'}}</p>
                  <p class="s_c333 s_lin_h28">地区：{{record.wechat ? record.wechat.area :'-'}}</p>
                  <p class="s_c333 s_lin_h28">会员等级：{{record.wechat ? record.wechat.vip_level :'-'}}</p>
                </div>
              </div>
            </template>
            <a href="javascript:;" class="s_omit width-120 ds-b">{{record.wechat ? record.wechat.nick_name :'-'}}</a>
          </a-popover>
          <p v-else>-</p>
        </template>
        <template v-slot:status="{ record }">
          <p>{{record.status?'正常':'禁用'}}</p>
        </template>
        <template v-slot:action="{ record }">
          <a-button v-has:dealerDetail="()=> {$router.push('/customer/dealer/dealer_detail?type=look&id='+record.dealer_id)}" class="m-r-10">详情</a-button>
          <a-button v-has:dealerEdit="()=> {$router.push('/customer/dealer/dealer_edit?type=edit&id='+record.dealer_id)}" class="m-r-10" type="primary">修改</a-button>
          <a-button v-has:dealerStatus="()=>dealerDisable(record)" class="m-r-10" danger>{{record.status?'禁用':'启用'}}</a-button>
          <a-button v-has:dealerDel="()=>delDealer(record)" v-if="!record.status" danger>删除</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
  <a-modal :keyboard="false" title="复制链接" centered :width='600' :footer="null" v-model:visible="visibleUrl" destroyOnClose>
    <div class="s_flex_bian_c">
      <div class="s_bor_r_cd9 p-r-20">
        <img class="width-160 height-160" :src="link.image" alt="">
        <p class="text-ac m-t-10">微信扫一扫立即预览</p>
      </div>
      <div class="width63">
        <p class="s_c333 s_font_b fz-16">复制地址</p>
        <div class="m-t-15 m-b-15 s_flex_bian_c">
          <a-input class="width80" v-model:value="link.link" readonly></a-input>
          <a-button type="primary" ghost @click="copy(link.link)">复制</a-button>
        </div>
        <p class="s_c999 ">可将链接复制到您的公众号菜单中</p>
      </div>
    </div>
  </a-modal>
  <a-modal :keyboard="false" title="添加经销商申请链接" centered :footer="null" v-model:visible="visibleInvite" destroyOnClose @cancel='formLink={}'>
    <a-form-item ref="" label="经销商级别" name="" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
      <a-select v-model:value="formLink.level_id" class="width100" placeholder="请选择经销商级别" @change='selectLevel'>
        <a-select-option v-for='item in levelList' :key='item.P_level_id' :value="item.level_id">{{item.level_name}}
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item ref="" label="上级经销商" name="" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" v-if="formLink.level_id">
      <a-row :gutter="10">
        <a-col :span="8" hidden>
          <a-input v-model:value='formLink.parent_dealer_id' readonly placeholder="上级ID"></a-input>
        </a-col>
        <a-col :span="20">
          <a-input v-model:value='formLink.name' readonly placeholder="上级名称"></a-input>
        </a-col>
        <a-col :span="4" v-if="formLink.level_id!=1">
          <a-button type="primary" @click='showDealer=true;dealer_type=2'>选择</a-button>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 8, offset: 5 }">
      <a-button type="primary" @click="Registered" :loading="confirmLoadingLink">
        生成申请链接
      </a-button>
    </a-form-item>
  </a-modal>
  <a-modal  :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect" :levelid='level' :mustShowHeadquarters='true'></selectDealer>
  </a-modal>
    <a-modal :keyboard="false" title="选择销售区" centered v-model:visible="showDealerArea" :width='1300' :footer="null" destroyOnClose>
    <selectDealerArea v-on:select="dealerAreaSelect"     :checkout="false"></selectDealerArea>
  </a-modal>
    <a-modal :keyboard="false" title="选择品牌" centered v-model:visible="brandVisible" @ok="handleBrandChoose" destroyOnClose>
        <a-form-item label="品牌"><selectBrand v-model:value="brand_id" /></a-form-item>
  </a-modal>
</template>
<script>
import {
  DownOutlined,
  PlusOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs, h, createVNode } from "vue";
import { message } from "ant-design-vue";
import {
  getDealerList,
  dealerDel,
  dealerEnable,
  getDealerLevelList,
  getInviteRegistered,
  dealserListExport,
  batchEditSubBrand
} from "@/api/dealer";
import { getClientsite } from "@/api/public";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 8,
  status: "",
  level_id: "",
  start_time: "",
  end_time: "",
  is_bind_wechat: "",
  type: "dealer_name",
  areaText: "",
  sale_cat_id: [],
  parent_dealer_id: "",
  up_name: "",
};
let defInvite = {
  name: "",
  dealer_sn: "",
  level_id: undefined,
};
export default {
  components: { PlusOutlined },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    let form = ref(defInvite);
    let formLink = ref({
      name: "总部",
      parent_dealer_id: 0,
    });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      dealer_type:1,
      showDealerArea: false, //销售大区
      visibleInvite: false,
      visibleUrl: false,
      listId: [],
      levelList: [],
      listLoading: false,
      time: [],
      total: 1,
      selectedRowKeys: [],
      content:
        "添加经销商资料，通过批量导入的经销商，导入成功后经销商状态默认为“正常”。",
      link: {
        image: "",
        link: "",
      },
      showDealer: false,
      level: null,
      confirmLoadingLink: false,
    });
    let columns = [
      {
        title: "经销商编号",
        dataIndex: "dealer_sn",
        key: "dealer_sn",
        fixed: "left",
      },
      {
        title: "经销商级别",
        dataIndex: "level_name",
        key: "level_name",
        fixed: "left",
      },
      {
        title: "经销商名称",
        dataIndex: "dealer_name",
        key: "dealer_name",
        slots: { customRender: "dealer_name" },
      },
      {
        title: "绑定微信账号",
        dataIndex: "account",
        key: "account",
        slots: { customRender: "account" },
      },
      {
        title: "手机号码",
        dataIndex: "leader_phone",
        key: "leader_phone",
      },
      {
        title: "负责人",
        dataIndex: "leader_name",
        key: "leader_name",
      },
      {
        title: "上级经销商",
        dataIndex: "parent_dealer_name",
        key: "parent_dealer_name",
      },
      {
        title: "状态",
        key: "status",
        slots: { customRender: "status" },
      },
      {
        title: "创建日期",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "最后登录时间",
        dataIndex: "last_login_time",
        key: "last_login_time",
        customRender: ({ record }) => {
          return record.last_login_time ? record.last_login_time : "从未登录";
        },
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    // 禁用启用经销商
    const dealerDisable = (e) => {
      $Modal.confirm({
        centered: true,
        title: e.status ? "禁用经销商" : "启用经销商",
        icon: createVNode(ExclamationCircleOutlined),
        content: h("div", {}, [
          h(
            "p",
            { className: "m-b-10" },
            e.status ? "经销商资料被禁用后：" : ""
          ),
          h(
            "p",
            { className: "m-b-10" },
            e.status ? "1、总部或其上级无法给该经销商出货；" : ""
          ),
          h(
            "p",
            { className: "m-b-10" },
            e.status ? "2、该经销商无法登录经销商后台；" : ""
          ),
          h("p", e.status ? "确定要禁用吗？" : "确定要启用吗？"),
        ]),
        onOk: async () => {
          let res = await dealerEnable(e.dealer_id).then((res) => res.data);
          if (iscode(res)) {
            message.success(res.msg);
            initData(search.value);
          } else {
            message.error(res.msg);
          }
        },
      });
    };
    //删除经销商
    const delDealer = (e) => {
      $Modal.confirm({
        centered: true,
        title: "经销商删除",
        content: "删除后该经销商将无法恢复，您确定要删除该经销商吗？",
        onOk: async () => {
          let res = await dealerDel(e.dealer_id).then((res) => res.data);
          if (iscode(res)) {
            message.success(res.msg);
            initData(search.value);
          } else {
            message.error(res.msg);
          }
        },
      });
    };
    //批量选中
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    };
    // 获取经销商等级
    const getLevel = async () => {
      let res = await getDealerLevelList().then((res) => res.data);
      if (iscode(res)) {
        state.levelList = res.data;
      } else {
        message.error(res.msg);
      }
    };
    const initData = async (values) => {
      state.listLoading = true;
      data.value = [];
      try {
        let res = await getDealerList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.list;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const inputSelect = (e) => {
      search.value.keyword = "";
    };
    // 获取地址
    const getLink = async (client_type) => {
      let result = await getClientsite({ client_type })
        .then((res) => res.data)
        .catch((error) => error);
      state.link = result.data;
      state.visibleUrl = true;
    };
    // 复制
    const copy = (link) => {
      var input = document.createElement("input"); // 直接构建input
      input.value = link; // 设置内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      message.success("复制成功");
    };
    onMounted(() => {
      getLevel();
      initData(search.value);
    });
    const dealerSelect = async (data) => {
     if( state.dealer_type==1){
         if (data == 0) {
        search.value.parent_dealer_id = 0;
        search.value.name = "总部";
      } else {
        search.value.parent_dealer_id = data.dealer_id;
        search.value.name = data.dealer_name;
      }
     }else{
         if (data == 0) {
        formLink.value.parent_dealer_id = 0;
        formLink.value.name = "总部";
      } else {
        formLink.value.parent_dealer_id = data.dealer_id;
        formLink.value.name = data.dealer_name;
      }
     }
    
      state.showDealer = false;
    };
    const Registered = async () => {
      if (!formLink.value.name) {
        message.error("请选择上级经销商！");
        return;
      }
      state.confirmLoadingLink = true;
      let result = await getInviteRegistered({ ...formLink.value })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        state.link = result.data;
        state.link.link = result.data.url;
        state.visibleUrl = true;
        state.visibleInvite = false;
      } else {
        iscode(result, true);
      }
      state.confirmLoadingLink = false;
    };
    // 选择等级
    const selectLevel = (e, s) => {
      state.level = s.key;
      formLink.value.parent_dealer_id = 0;
      formLink.value.name = "总部";
    };
    const exportTable = async () => {
      let result = await dealserListExport({ ...search.value, limit: 10000 })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        window.open(result.data.file_url);
      }
    };
    // 选择销售大区
    const dealerAreaSelect = (data) => {
      state.showDealerArea = false;
      search.value.sale_cat_id = data.id;
      search.value.areaText = data.sale_cat_name;
    };

    // 修改品牌
    const brandVisible=ref(false)
    const brand_id=ref('')
    const batchEditSubB=()=>{
      console.log( state.selectedRowKeys)
      if(!state.selectedRowKeys.length){
        message.error("请选择经销商")
        return
      }
      brandVisible.value=true
    }
    const handleBrandChoose=async()=>{
      let result=await batchEditSubBrand({type:1,ids:state.selectedRowKeys,sub_brand_id:brand_id.value}).then(res=>res.data).catch(error=>error)
      if(iscode(result,true)){
        brandVisible.value=false
       initData(search.value);
      } 
    }
    return {
      ...toRefs(state),
      search,
      formLink,
      form,
      data,
      getLink,
      copy,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      dealerDisable,
      delDealer,
      onSelectChange,
      inputSelect,
      dealerSelect,
      Registered,
      selectLevel,
      exportTable,
      dealerAreaSelect,
      brandVisible,
      batchEditSubB,
      handleBrandChoose,
      brand_id
    };
  },
};
</script>